import React from 'react';
import { ConnectionStatusProperties } from './connectionStatus.properties';

import './connectionStatus.styles.scss';
import { useTranslation } from 'react-i18next';

export function ConnectionStatusComponent(props: ConnectionStatusProperties) {

  const { t } = useTranslation();

  return <div className="ConnectionComponent Modal Right">
    <div className="Header">
      <span>{`${t("connection-status.title")}`}</span>
      <i className="las la-times" onClick={() => { props.setIsShowingConnectionStatus(false) }}></i>
    </div>
    <div className="Body">
      <ul className='Value-Group'>
        <li>
          <span className='list-title'>{`${t("connection-status.status")}:`}</span>
          <span className='list-value'>{`${t(`connection-status.status-${props.socketConnectionStatus}`)}`}</span>
        </li>
        <li>
          <span className='list-title'>{`${t("connection-status.latency")}:`}</span>
          <span className='list-value'>{`${props.latency.toFixed(2)} ms`}</span>
        </li>
        <li>
          <span className='list-title'>{`${t("connection-status.jitter")}:`}</span>
          <span className='list-value'>{`${props.jitter.toFixed(2)} ms`}</span>
        </li>
        {/* Download/Upload speeds and packet loss removed per product decision */}
      </ul>
    </div>
  </div>
}
